module.exports = __webpack_public_path__ + "img/zw.879db58f.svg";